import React from 'react'
import './AsyncLoader.css'

type AsyncLoaderProps = {
  className?: string,
  color?: string,
  testId?: string
}

const AsyncLoader = (props: AsyncLoaderProps) => {
  let { className, color = "#fff", testId = 'cs-async-loader', ...otherProps } = props;
  return (
    <div className={`AsyncLoader ${className ? className : ''}`} {...otherProps} data-test-id={testId}>
      <div className="AsyncLoader--dot" style={{ backgroundColor: color }}></div>
      <div className="AsyncLoader--dot" style={{ backgroundColor: color }}></div>
      <div className="AsyncLoader--dot" style={{ backgroundColor: color }}></div>
    </div>
  )
}


export default AsyncLoader